import React from 'react';
interface FloatingMetalButtonProps {
  emoji: string;
  className?: string;
  style?: React.CSSProperties;
}
export const FloatingMetalButton: React.FC<FloatingMetalButtonProps> = ({
  emoji,
  className = '',
  style
}) => {
  return <div className={`floating-metal ${className}`} style={style} data-id="element-294">
      <div className="metal-outline" data-id="element-295">
        <div className="metal-inner" data-id="element-296">{emoji}</div>
      </div>
    </div>;
};